import { parseAsString, parseAsStringLiteral, useQueryState } from 'nuqs';
import { useCallback } from 'react';

import {
  DEFAULT_LOG_LEVEL,
  DEFAULT_LOG_TYPE,
  DEFAULT_SORT_DIRECTION,
  DEFAULT_TIME_RANGE
} from '../constants';

const LOG_LEVELS = ['ALL SEVERITIES', 'INFO', 'ERROR', 'WARN'] as const;
const LOG_TYPES = ['ALL SOURCES', 'INTERNAL', 'LOG_CONNECTOR'] as const;
const SORT_DIRECTIONS = ['ASC', 'DESC'] as const;

export function useFilterUrlState() {
  const [pipelineName, setPipelineName] = useQueryState(
    'pipelineName',
    parseAsString.withDefault('')
  );
  const [pipelineVersion, setPipelineVersion] = useQueryState(
    'pipelineVersion',
    parseAsString.withDefault('')
  );
  const [logMessage, setLogMessage] = useQueryState(
    'logMessage',
    parseAsString.withDefault('')
  );
  const [pipelineKey, setPipelineKey] = useQueryState(
    'pipelineKey',
    parseAsString.withDefault('')
  );

  const [level, setLevel] = useQueryState(
    'level',
    parseAsStringLiteral(LOG_LEVELS).withDefault(DEFAULT_LOG_LEVEL)
  );
  const [logType, setLogType] = useQueryState(
    'logType',
    parseAsStringLiteral(LOG_TYPES).withDefault(DEFAULT_LOG_TYPE)
  );

  const [time, setTime] = useQueryState(
    'time',
    parseAsString.withDefault(DEFAULT_TIME_RANGE)
  );
  const [dateFrom, setDateFrom] = useQueryState('dateFrom', parseAsString);
  const [dateTo, setDateTo] = useQueryState('dateTo', parseAsString);

  const [direction, setDirection] = useQueryState(
    'direction',
    parseAsStringLiteral(SORT_DIRECTIONS).withDefault(DEFAULT_SORT_DIRECTION)
  );

  const clearAllFilters = useCallback(() => {
    setPipelineName('');
    setPipelineVersion('');
    setLogMessage('');
    setPipelineKey('');
    setLevel(DEFAULT_LOG_LEVEL);
    setLogType(DEFAULT_LOG_TYPE);
    setTime(DEFAULT_TIME_RANGE);
    setDateFrom(null);
    setDateTo(null);
    setDirection(DEFAULT_SORT_DIRECTION);
  }, [
    setPipelineName,
    setPipelineVersion,
    setLogMessage,
    setPipelineKey,
    setLevel,
    setLogType,
    setTime,
    setDateFrom,
    setDateTo,
    setDirection
  ]);

  return {
    filters: {
      pipelineName,
      pipelineVersion,
      logMessage,
      pipelineKey,
      level,
      logType,
      time,
      dateFrom,
      dateTo,
      direction
    },
    setters: {
      setPipelineName,
      setPipelineVersion,
      setLogMessage,
      setPipelineKey,
      setLevel,
      setLogType,
      setTime,
      setDateFrom,
      setDateTo,
      setDirection
    },
    clearAllFilters
  };
}
